import type { AxiosPromise } from 'axios';
import { type ClientContext, ContextClient } from '~/services/contextClient';
import MembershipStatusDefinitionsClientFactory from './membershipStatusDefinitionsClient.factory';
import type {
    MembershipStatusDefinitionFormData,
    MembershipStatusDefinitionsClientInterface,
    MembershipStatusDefinitionsResponse,
} from './membershipStatusDefinitionsClient.types';

class MembershipStatusDefinitionsClient extends ContextClient<MembershipStatusDefinitionsClientInterface> {
    constructor() {
        super(MembershipStatusDefinitionsClientFactory);
    }

    getMembershipStatusDefinitions(context: ClientContext): AxiosPromise<MembershipStatusDefinitionsResponse> {
        const client = this.getClient(context);
        return client.getMembershipStatusDefinitions();
    }

    updateMembershipStatusDefinitions(
        context: ClientContext,
        data: { definitions: MembershipStatusDefinitionFormData[] },
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<MembershipStatusDefinitionsResponse> {
        const client = this.getClient(context);
        return client.updateMembershipStatusDefinitions(data, extraConfig);
    }
}

export default new MembershipStatusDefinitionsClient();
